import { useEffect, useState } from 'react';

/**
 * After `loading` becomes false, waits two animation frames then sets `revealed` true
 * so opacity transitions run after layout without a blank flash.
 */
export function useSynchronizedReveal(loading: boolean): boolean {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    if (loading) {
      setRevealed(false);
      return;
    }
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => setRevealed(true));
    });
    return () => cancelAnimationFrame(id);
  }, [loading]);

  return revealed;
}
